import { render, staticRenderFns } from "./footerData.vue?vue&type=template&id=6c862586"
import script from "./footerData.vue?vue&type=script&lang=js"
export * from "./footerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports